import * as React from "react"
import { formatDate, translateCountryName } from "@ui-seeker/utils"

import { RetailerBlock } from "@components"


export default function retailerColumn() {
	return [{
		name: 'date', label: 'date',
		options: {
			display: 'excluded',
			customBodyRowRender: v => formatDate(v, { isString: true })
		}
	}, {
		name: 'country', label: 'Market',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'externalSeller', label: 'Is 3P?',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: "retailer", label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country, siteURL }) => <RetailerBlock 
				retailer={value}
				country={country}
				siteURL={siteURL}
			/>
		}
	}]
}